(ns shared.core.debug.views
  (:require [shared.core.reactive :as re]
            [shared.core.debug.data :as debug.d]
            [shared.core.debug.datafrisk.views :refer [data-frisk-shell]]
            [shared.core.components.components :as c]
            [shared.core.util :as util]
            [shared.core.style :as style]
            [shared.core.config :as config]
            [clojure.string :as s]))

(defn debug-toolbar-results []
  [data-frisk-shell @(re/subscribe [:debug/app-db-search-results-])])

(defn debug-toolbar []
  (let [toolbar?- (re/subscribe [:debug/toolbar?-])
        toasts-disabled?- (re/subscribe [:toasts/disabled?-])]
    (re/create-class
      {:component-did-mount
       #(re/dispatch [:debug/initialize-event-logs])
       :reagent-render
       (fn [{:keys [style]}]
         (when @toolbar?-
           [c/theme
            :div {:style (merge {:background-color (style/color :white :base)
                                 :border-bottom (str "1px solid " (style/color :gray :base))
                                 :box-shadow "rgba(0, 0, 0, 0.16) 0px 0px 14px 0px"
                                 :display :flex
                                 :flex-direction :column
                                 :position :absolute
                                 :top 0
                                 :left 0
                                 :width "100%"
                                 :z-index (inc (style/z :above-all))}
                                style)
                  :theme (style/dark-style {:background-color (style/dark-color :surface :base)
                                            :border-bottom (str "1px solid " (style/dark-color :surface :lighter-1))})}
            [:div {:style {:flex "0 0 auto"
                           :display :flex
                           :align-items :center
                           :padding "5px 10px"}}
             [c/input {:form-path debug.d/root-path
                       :form-name :search
                       :val-subscribe [:debug/search-]
                       :placeholder "DB Path e.g. :router :current"
                       :style {:width 400}
                       :on-key-down #(when (util/enter-key-event? %)
                                       (let [v (.. % -target -value)]
                                         (re/dispatch [:debug/search-app-db v])
                                         (.preventDefault %)
                                         (.stopPropagation %)))}]
             [c/input {:form-path debug.d/root-path
                       :form-name :re-frame-event
                       :val-subscribe [:debug/re-frame-event-]
                       :placeholder "Dispatch e.g. [:router/go [:version]]"
                       :style {:margin-left 10
                               :width 300}
                       :on-key-down #(when (util/enter-key-event? %)
                                       (let [v (.. % -target -value)]
                                         (re/dispatch [:debug/dispatch-event v])
                                         (.preventDefault %)
                                         (.stopPropagation %)))}]
             [:div {:style {:flex 1}}]
             [c/a {:on-click #(re/dispatch [:router/go [:devtools/graphiql]])
                   :style {:margin-left 15}}
              "GraphiQL"]
             [c/a {:on-click #(re/dispatch [:router/go [:devtools/voyager]])
                   :style {:margin-left 15}}
              "Voyager"]
             [:div {:style {:background-color (style/color :gray :shade-7)
                            :margin "0 15px"
                            :height 25
                            :width 1}}]
             [c/toggle {:on-click #(re/dispatch [:toasts/toggle-disabled])
                        :on? (not @toasts-disabled?-)}
              "Toasts"]
             [c/toggle {:on-click #(re/dispatch [:debug/toggle-event-logs])
                        :on? @config/debug?*
                        :style {:margin-left 10}}
              "Event Logs"]
             [c/toggle {:form-path debug.d/root-path
                        :form-name :app-rerender-on-load?
                        :val-subscribe [:debug/app-rerender-on-load?]
                        :style {:margin-left 10}}
              "Re-render App on Load"]
             [:div {:style {:background-color (style/color :gray :shade-7)
                            :margin "0 10px 0 15px"
                            :height 25
                            :width 1}}]
             [c/tooltip
              {:placement :bottom
               :tooltip-content "Close Toolbar"
               :target-content [c/material-icon {:icon-type :close
                                                 :on-click #(re/dispatch [:debug/toggle-toolbar])
                                                 :style {:cursor :pointer}}]}]]
            [debug-toolbar-results]]))})))
